<template>
  <div class="wrap">
    <div class="title">您还可以<span>享受以下权益</span></div>
    <div class="title">确定要{{ showDes }}吗？</div>
    <div class="cancel-wrap">
      <div class="irregular-badge">{{ showDes }}</div>
      <div class="cancel-content">
        <div class="cancel-content-title">{{ h5Data.elementOneText }}</div>
        <div class="cancel-content-desc">
          <template v-if="refundAmount">
            <div class="cancel-content-desc-title">可退费</div>
            <div class="cancel-content-desc-value">
              <span>{{ refundAmount }}</span
              >元
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="not-cancel-wrap">
      <div class="not-cancel-tips">暂不取消</div>
      <div class="vs">VS</div>
      <div class="cancel-title">{{ h5Data.elementTwoText }}</div>
      <div class="not-cancel-content-wrap">
        <div
          :key="item.leftContent"
          v-for="item in h5Data.retainBenefitContentList"
          class="not-cancel-item-wrap"
        >
          <div class="not-cancel-item">
            <div class="not-cancel-item-label">
              {{ item.leftContent }}
            </div>
            <div class="not-cancel-item-value">{{ item.rightContent }}</div>
          </div>
          <div class="not-cancel-item-div" v-if="item.tipContent">
            温馨提示：{{ item.tipContent }}
          </div>
        </div>
        <div
          class="not-cancel-item benefit-item"
          v-for="item in h5Data.benefitContentList"
          :key="item.leftContent"
        >
          <div class="not-cancel-item-label">
            {{ item.leftContent }}
          </div>
          <div class="not-cancel-item-value">{{ item.rightContent }}</div>
        </div>
      </div>
      <div class="amount-title">累计可得</div>
      <div class="amount-value">
        {{ h5Data.bottomText }}<span>{{ h5Data.totalAmount }}</span
        >元
      </div>
    </div>
    <div class="btn" @click="handleNotCancel">暂不取消</div>
    <div class="cancel-btn" @click="handleCancel">放弃权益 仍要取消</div>
    <H5RetainModal
      :show="retainModalShow"
      @close="retainModalShow = $event"
      :modalData="retainModalData"
    />
  </div>
</template>

<script>
import Vue from "vue";
import {
  defineComponent,
  ref,
  computed,
  onMounted,
} from "@vue/composition-api";
import { useStore, useRoute, useRouter } from "@/components/use/base";

import RetainModal from "@/views/index/moreCard/member/JyComponent/RetainModal.vue";
import {
  getJiayinRetainH5,
  getJiayinH5RetainModal,
  fetchRefund,
  cancelDeduction,
} from "@/apis/jiayin";

import H5RetainModal from "./H5RetainModal.vue";

const vm = Vue.prototype;

export default defineComponent({
  components: {
    RetainModal,
    H5RetainModal,
  },
  setup() {
    const router = useRouter();
    const store = useStore();
    const route = useRoute();
    const { orderId, channelSource, triggerNode } = route.query;

    const retainModalShow = ref(false);
    const retainModalData = ref({});

    const h5Data = computed(() => store.state.JiaYin.h5Data);
    const showDes = computed(() => {
      return {
        cancel_renew_package_popup: "关闭续费",
        user_refund_package_popup: "申请退费",
        cancel_deduct_package_popup: "取消扣费",
      }[triggerNode];
    });

    const refundAmount = computed(() => {
      return Number(h5Data.value.refundAmount);
    });

    const fetchH5Data = async () => {
      const loading = vm.$loading();
      try {
        const { data } = await getJiayinRetainH5({
          order_id: orderId,
        });
        store.commit("setH5Data", data);
      } finally {
        loading.clear();
      }
    };

    const fetchH5RetainModal = async () => {
      const loading = vm.$loading();
      try {
        // cancel_deduct_package_popup 取消扣费H5挽留弹窗
        // cancel_renew_package_popup  取消续费H5挽留弹窗
        // user_refund_package_popup 用户发起退费H5挽留弹窗
        const { data } = await getJiayinH5RetainModal({
          order_id: orderId,
          channel_source: channelSource,
          trigger_node: triggerNode,
        });
        if (data.isNeedPop) {
          retainModalShow.value = true;
          retainModalData.value = data;
        }
      } finally {
        loading.clear();
      }
    };
    onMounted(async () => {
      await fetchH5Data();
      await fetchH5RetainModal();
    });

    const handleNotCancel = () => {
      router.go(-1);
    };

    const handleCancel = async () => {
      if (triggerNode === "cancel_deduct_package_popup") {
        const { data } = await cancelDeduction({
          orderId: store.state.orderId,
        });
        if (data.isSuccess) {
          vm.$toast("取消扣费已申请成功，感谢您的使⽤～");
          await store.dispatch("fetchUserInfo");
        }
      } else if (triggerNode === "user_refund_package_popup") {
        const { data } = await fetchRefund({
          orderId: store.state.orderId,
        });
        if (data.refundable) {
          vm.$toast("申请退费已提交，感谢您的使用～");
          await store.dispatch("fetchUserInfo");
        }
      } else if (triggerNode === "cancel_renew_package_popup") {
        store.commit("setShowCancelRenewalModal", true);
      }
      router.go(-1);
    };

    return {
      handleCancel,
      handleNotCancel,
      retainModalShow,
      retainModalData,
      refundAmount,
      h5Data,
      showDes,
    };
  },
});
</script>

<style lang="less" scoped>
.wrap {
  min-height: 100vh;
  background: linear-gradient(
    105deg,
    rgba(245, 229, 205, 0.43) 0%,
    rgba(255, 241, 220, 0.43) 10%,
    rgba(255, 255, 255) 100%
  );
  padding: 21px 16px 45px 16px;
  box-sizing: border-box;

  .title {
    font-weight: 600;
    font-size: 20px;
    color: #333333;
    line-height: 20px;

    span {
      color: #e4681d;
    }

    &:not(:last-child) {
      margin-bottom: 13px;
    }
  }

  .cancel-wrap {
    position: relative;
    width: 343px;
    height: 67px;
    background: #ffffff;
    border-radius: 8px;
    margin-top: 24px;
    top: 0;
    left: 0;

    .irregular-badge {
      position: absolute;
      padding: 3px 10px 3px 8px;
      font-size: 11px;
      font-weight: 500;
      color: #b8b8b8;
      background: #f1f1f1;
      border-top-left-radius: 8px;
      clip-path: polygon(0 0, 100% 0, 90% 100%, 0 100%);
    }
  }

  .btn {
    height: 44px;
    background: linear-gradient(90deg, #4082e7 0%, #3254f2 100%);
    border-radius: 26px;
    font-weight: 600;
    font-size: 17px;
    color: #ffffff;
    line-height: 44px;
    text-align: center;
    margin-top: 24px;
  }

  .cancel-btn {
    margin-top: 16px;
    font-weight: 400;
    font-size: 12px;
    color: #666666;
    line-height: 17px;
    text-align: center;
  }

  .cancel-content {
    padding-top: 14px;
    padding-left: 19px;
    padding-right: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;

    .cancel-content-title {
      font-weight: 600;
      font-size: 12px;
      color: #000000;
      position: relative;
      &::after {
        position: absolute;
        content: "";
        display: block;
        width: 38px;
        height: 3px;
        background: #ff8035;
        border-radius: 2px;
        opacity: 0.54;
        bottom: 0;
        left: 0;
      }
    }

    .cancel-content-desc {
      height: 55px;
    }

    .cancel-content-desc-title {
      font-weight: 600;
      font-size: 10px;
      color: #3b3b3b;
      line-height: 16px;
      text-align: right;
    }

    .cancel-content-desc-value {
      margin-top: 7px;
      display: flex;
      align-items: center;
      font-weight: 600;
      font-size: 10px;
      color: #000000;
      line-height: 16px;

      span {
        font-weight: 600;
        font-size: 18px;
        color: #000000;
        line-height: 16px;
        margin-right: 2px;
      }
    }
  }

  .not-cancel-wrap {
    margin-top: 12px;
    background: #ffffff;
    border-radius: 8px;
    border: 2px solid #ff8035;
    position: relative;
    padding: 34px 16px 24px 16px;

    .not-cancel-tips {
      position: absolute;
      top: -2px;
      left: -2px;
      padding: 3px 10px 3px 8px;
      border-top-left-radius: 8px;
      background: #ff8035;
      clip-path: polygon(0 0, 100% 0, 90% 100%, 0 100%);
      font-weight: 600;
      font-size: 11px;
      color: #ffffff;
      line-height: 16px;
      text-align: center;
    }

    .vs {
      width: 32px;
      height: 32px;
      background: #ff8035;
      border-radius: 50%;
      position: absolute;
      top: 0;
      left: 50%;
      transform: translate(-50%, -50%);

      font-weight: 600;
      font-size: 16px;
      color: #ffffff;
      line-height: 32px;
      text-align: center;
    }

    .cancel-title {
      font-weight: 600;
      font-size: 14px;
      color: #000000;
      position: relative;
      width: fit-content;

      &::after {
        position: absolute;
        content: "";
        display: block;
        width: 81px;
        height: 3px;
        background: #ff8035;
        border-radius: 2px;
        opacity: 0.54;
        right: 0;
        bottom: 0;
      }
    }

    .not-cancel-content-wrap {
      margin-top: 24px;
      border-bottom: 1px dashed #f5e5cd;
      padding-bottom: 16px;

      .not-cancel-item-wrap {
        &:not(:last-child) {
          margin-bottom: 8px;
        }
      }

      .not-cancel-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-weight: 500;
        font-size: 12px;

        &.benefit-item {
          &:not(:last-child) {
            margin-bottom: 8px;
          }
        }

        .not-cancel-item-value {
          color: #000000;
        }

        .not-cancel-item-value {
          font-weight: 600;
          color: #ff8035;
        }
      }

      .not-cancel-item-div {
        background: #fff7f2;
        font-weight: 500;
        font-size: 12px;
        color: #757575;
        line-height: 16px;
        padding: 11px 12px;
        margin-top: 10px;
      }
    }

    .amount-title {
      font-weight: 600;
      font-size: 12px;
      color: #ff8035;
      line-height: 16px;
      text-align: right;
      margin-top: 16px;
    }

    .amount-value {
      margin-top: 9px;
      font-weight: 600;
      font-size: 14px;
      color: #ff8035;
      text-align: right;

      span {
        font-size: 18px;
      }
    }
  }
}
</style>
